// Description: Footer of the creating campaign form
// Updated: 26/09/2025
// Author: Simon Franklin

// React
import React from 'react'

// Material UI Components
import { Button } from '@mui/material'

// Components and functions for the project
import { useNavigate } from 'react-router-dom'

// Render The Component
const CampaignCreationFooter = ({ setCurrentStep, currentStep, canAdvance, error, handleFinish, edit = false }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);

    const handleAdvance = () => {
        const moveForward = canAdvance();

        if (moveForward === true) {
            setCurrentStep((prev) => prev + 1)
        } else {
            console.log(error);
            return;
        }
    }

    const onSubmit = async () => {
        setLoading(true);

        try {
            await handleFinish();
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div style={{ display: "flex", gap: "16px", marginTop: "22px" }}>
            <Button onClick={() => currentStep === 0 ? navigate("/campanhas") : setCurrentStep((prev) => prev - 1)} variant="outlined" sx={{ width: "81px", height: "39px", padding: "10px" }}>
                {
                    currentStep === 0 ? "Cancelar" : "Voltar"
                }
            </Button>
            <Button disabled={loading} onClick={currentStep === 4 ? onSubmit : handleAdvance} variant="contained" sx={{ width: currentStep !== 4 ? "81px" : "auto", height: "39px", padding: "10px" }}>
                {
                    currentStep === 4 ? edit === true ? "Salvar alterações" : "Criar campanha" : "Avançar"
                }
            </Button>
        </div>
    )
}

export default CampaignCreationFooter